import React from "react";

import "./Home.css";

export default function Home() {
  return (
    <div className="home">
    </div>
  );
}
